import { isStaffType } from '@/enums/merchant-type.enum'
import { dateFormat } from '@/filters/index.js'

class InvitesManager {
  data = []

  constructor (data) {
    this.data = data
  }

  /**
   *
   * @param {*} invite
   * @returns
   */
  getPermission (invite) {
    return invite.type.key === 'Staff' ? invite.role.value : invite.type.value
  }

  /**
   *
   * @param {*} statusInvite
   * @returns
   */
  resendInviteDisabled (statusInvite) {
    const status = statusInvite.toLowerCase()
    return !['expired', 'refused', 'pending'].includes(status)
  }

  /**
   *
   * @param {*} statusInvite
   * @returns
   */
  cancelInviteDisabled (statusInvite) {
    const status = statusInvite.toLowerCase()
    return status !== 'pending'
  }

  /**
   *
   * @param {*} invite
   * @returns
   */
  convertToView (invite) {
    const {
      id,
      invited_email,
      inviter_name: inviterName,
      inviter_email,
      invited_name,
      status,
      created_at,
      canceled_at,
      expires_at
    } = invite

    const isStaff = isStaffType(invite.type.key)
    return {
      id,
      invited_email,
      invited_name,
      status,
      permission: this.getPermission(invite),
      showResendButton:
        isStaff && !this.resendInviteDisabled(invite.status.key),
      showRemoveButton:
        isStaff && !this.cancelInviteDisabled(invite.status.key),
      created_at: dateFormat(created_at, 'date'),
      expires_at: dateFormat(expires_at, 'dateAndHour'),
      canceled_at: dateFormat(canceled_at, 'dateAndHour'),
      inviter_name: inviterName || '',
      inviter_email
    }
  }

  /**
   *
   * @param {*} dataDefault
   * @returns
   */
  adapter (dataDefault) {
    return dataDefault.map(invite => {
      return this.convertToView(invite)
    })
  }

  /**
   * Executes all the methods
   * @returns Array
   */
  get () {
    return this.adapter(this.data)
  }

  getOne () {
    if (!this.data.length) throw new Error('Missing argument data!')
    return this.get()[0]
  }
}

export default InvitesManager
